import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    add_role,
  delete_role,
  get_role,
  update_role,
  get_role_list
} from "../Service/ApiServices";
import { toast } from "react-toastify";

const initialState = {
  roles: [],
  rolelist: [],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
  },
};
// Async Thunks for API Calls
export const fetchRoleList = createAsyncThunk(
  'classes/fetchRoleList',
  async ({token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await get_role_list(token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async Thunks for API Calls
export const fetchRole = createAsyncThunk(
  "role/fetchRole",
  async ({ page, page_size, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await get_role(page, page_size, token,school_id,signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createRole = createAsyncThunk(
  "role/createRole",
  async ({ data, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await add_role(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateRole = createAsyncThunk(
  "role/updateRole",
  async ({ data, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await update_role(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "role/deleteRole",
  async ({ ids, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_role({ ids }, token, school_id,signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const classSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, school_id, name } = action.payload;
      state.formData = { id, school_id, name };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
      };
    },
    setRole(state, action) {
      state.roles = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    // section list 
    .addCase(fetchRoleList.fulfilled, (state, action) => {
      state.rolelist = action.payload.data;
    })
    .addCase(fetchRoleList.rejected, (state, action) => {
      state.rolelist = [];

    })
      // Fetch Classes
      .addCase(fetchRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchRole.rejected, (state, action) => {
        state.loading = false;
        state.roles = [];
        state.error = action.payload;
      })

      // Add Class
      .addCase(createRole.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createRole.rejected, (state, action) => {
      
        state.addLoading = false;
               state.error = action?.payload?.data?.message;
               const errorMessage = action?.payload?.data?.message || "Something went wrong!";
               toast.info(errorMessage);  
               state.IsEditing = false;
      })                                                                                                                                                                                     
      // Update Class
      .addCase(updateRole.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.addLoading = false;
               state.error = action?.payload?.data?.message;
               state.IsEditing = false;
               const errorMessage = action?.payload?.data?.message || "Something went wrong!";
               toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deleteRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setRole,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize
} = classSlice.actions;
export default classSlice.reducer;
